import React from "react";
import styled from "styled-components";

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  border-radius: 12px;
  background-color: "#D5D6DA"};
`;

type ProgressBarFillProps = {
  progress: number;
};

const ProgressBarFill = styled.div<ProgressBarFillProps>`
  width: ${props => props.progress}%;
  height: 8px;
  border-radius: 12px;
  background: "#000000";
  transition: width 0.2s ease-in-out;
`;

interface ProgressBarProps {
  progress: number;
}

export const ProgressBar = ({ progress }: ProgressBarProps) => {
  const progressPercentage = Math.max(0.01, Math.min(1, progress)) * 100;
  return (
    <ProgressBarContainer>
      <ProgressBarFill progress={progressPercentage} />
    </ProgressBarContainer>
  );
};

export default ProgressBar;
